import React, { ChangeEvent, useEffect, useState } from "react";
import TextFieldWithLabel from "./TextFieldWithLabel";

type ImageUploadProps = {
  onUpload: Function;
  file?: any;
  title?: string;
};

const ImageUploader: React.FC<ImageUploadProps> = ({
  onUpload,
  file,
  title,
}) => {
  const [previewImage, setPreviewImage] = useState<string | null>(null);

  const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onUpload(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (file && typeof file == "object") {
      setPreviewImage(`data:${file.type};base64,${file.image}`);
    } else if (file && typeof file == "string") {
      setPreviewImage("/" + file);
    }
  }, [file]);

  return (
    <div className="flex w-full flex-col items-center justify-center">
      <TextFieldWithLabel
        textFieldProps={{ type: "file", accept: "image/*" }}
        label={title || "Upload Image"}
        id="upload"
        value=""
        onChange={handleImageChange}
      />
      {previewImage && (
        <img
          src={previewImage}
          alt="Preview"
          className="mt-4 rounded-lg shadow-md"
        />
      )}
    </div>
  );
};

export default ImageUploader;
